import moment from 'moment'
import { getMetarIcon } from '../icons.js';
import { convertTemperature, convertDirection, convertMsToMph, convertHpaToInches, convertToTime, convertToMixedCase } from '../helpers.js';

const renderMETAR = (currents) => {
  const metar = currents.metars.data;
  const astronomy = currents.astronomy.data

  const sunrise = astronomy.sun.rise
  const sunset = astronomy.sun.set
  const isDaylight = moment().utc().isBetween(sunrise, sunset)

  document.getElementById('metar-timestamp').innerHTML = convertToTime(metar.issuetime).withMins
  document.getElementById('metar-location').innerHTML = convertToMixedCase(metar.station.name.split(',')[0])
  document.getElementById('metar-icon').setAttribute('src', getMetarIcon(metar.weather_code.value, isDaylight));
  document.getElementById('metar-skies').innerHTML = metar.weather_code.text

  if (metar.temperature.wind_chill) {
    document.getElementById('metar-feelslike').innerHTML = `${convertTemperature(metar.temperature.wind_chill).fahrenheit}&deg;`
  } else if (metar.temperature.heat_index) {
    document.getElementById('metar-feelslike').innerHTML = `${convertTemperature(metar.temperature.heat_index).fahrenheit}&deg;`
  } else {
    document.getElementById('metar-feelslike').innerHTML = `${convertTemperature(metar.temperature.value).fahrenheit}&deg;`
  }
  
  document.getElementById('metar-temp').innerHTML = `${convertTemperature(metar.temperature.value).fahrenheit}&deg;`
  document.getElementById('metar-dewpoint').innerHTML = `${convertTemperature(metar.temperature.dew_point).fahrenheit}&deg;`
  document.getElementById('metar-pressure').innerHTML = `${convertHpaToInches(metar.pressure.value).toFixed(2)}"`
  document.getElementById('metar-winds').innerHTML = `${convertDirection(metar.wind.dir).short} ${convertMsToMph(metar.wind.speed)}`

  if (metar.wind.gusts) {
    document.getElementById('metar-gusts').innerHTML = `G${metar.wind.gusts}`
  }

  document.getElementById('metar-sunrise').innerHTML = convertToTime(astronomy.sun.rise).withMins
  document.getElementById('metar-sunset').innerHTML = convertToTime(astronomy.sun.set).withMins
}

export { renderMETAR }